
import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Flex, MainHeadline, PageFooter, PageWrapper, Table, Th, Tr } from 'styling/GlobalStyles'
import { getParams, handlePagination } from 'utils/helpers'
import { clearInventoryDashboard, getInventoryItemsDashboard } from 'features/inventory/inventoryItemsSlice'
import { TitleText } from 'styling/Typography'
import { FilterEnum, LinkEnum } from 'components/Filter/SingleFilter'

export const InventoryDashboard = () => {
    const { dashboard } = useSelector((store: RootState) => store.inventoryItems)
    const [params, setParams] = useState<any>(getParams({ location }))

    useQueryPagination({ fetchFunctions: [getInventoryItemsDashboard], cleanUpFunctions: [clearInventoryDashboard], params })

    const filters = [
        {
            type: FilterEnum.ASYNC_SELECT,
            name: 'Location',
            link: LinkEnum.LOCATIONS,
            propName: 'locationId',
            single: true
        },
        {
            type: FilterEnum.ASYNC_SELECT,
            link: LinkEnum.INVENTORY_CATEGORIES,
            name: 'Category',
            state: null,
            single: true,
            propName: 'categoryId'
        }
    ]

    return <>
        <NavBar input placeholder='Search items...' setParams={setParams} filterOptions={filters} enableTemporaryManualClosing />
        <PageWrapper>
            <Flex between center mb='16' >
                <MainHeadline>Inventory Dashboard</MainHeadline>
                <Flex gap='1rem' >
                    <TitleText weight='bold' > Low Stock: </TitleText>
                    <TitleText weight='bold' color='#ff9900' >{dashboard?.lowStockCount || 0}</TitleText>
                </Flex>

            </Flex>
            {!dashboard?.data?.length ? (
                <NoItems title='Items' />
            ) : (
                <Table width='100%' >
                    <Th next>
                        <Td w='20%' noTooltip text='NAME' />
                        <Td w='20%' noTooltip text='SKU' />
                        <Td w='20%' noTooltip text='QUANTITY' />
                        <Td w='20%' noTooltip text='MIN LEVEL' />
                        <Td w='20%' noTooltip text='IS LOW STOCK' />
                    </Th>
                    {dashboard?.data.map((item) => {
                        return (
                            <Tr key={item.id}>
                                <Td w='20%' text={item.name} />
                                <Td w='20%' text={item.sku} />
                                <Td w='20%' text={item.quantity} />
                                <Td w='20%' text={item.minLevel} />
                                <Td w='20%' text={item.isLowStock ? 'Yes' : 'No'} />
                            </Tr>
                        )
                    })}
                </Table>
            )}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(dashboard?.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}